package org.catharsis.spendtel.feature.presentation.web

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.imePadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.navigation.NavHostController
import org.catharsis.spendtel.core.navigation.AppRoutes
import org.catharsis.spendtel.feature.legal.LegalDocumentBody
import org.catharsis.spendtel.feature.legal.LegalDocumentType
import org.catharsis.spendtel.feature.legal.legalDocument
import org.catharsis.spendtel.feature.legal.legalDocumentRoute
import org.catharsis.spendtel.feature.presentation.expensereport.SpendTelReportColors

private val webLegalMaxWidth = 720.dp

@Composable
fun WebLegalDocumentScreen(
    navHostController: NavHostController,
    documentType: LegalDocumentType,
) {
    val document = legalDocument(documentType)
    val scrollState = rememberScrollState()
    val companionType = when (documentType) {
        LegalDocumentType.PrivacyPolicy -> LegalDocumentType.TermsAndConditions
        LegalDocumentType.TermsAndConditions -> LegalDocumentType.PrivacyPolicy
    }
    val companionDocument = legalDocument(companionType)

    Box(
        modifier = Modifier
            .fillMaxSize()
            .imePadding(),
    ) {
        WebAmbientPageBackground(modifier = Modifier.fillMaxSize())

        WebViewportScrollColumn(
            scrollState = scrollState,
            modifier = Modifier.fillMaxSize(),
            maxContentWidth = webLegalMaxWidth,
        ) {
            Column(
                modifier = Modifier.padding(horizontal = 24.dp, vertical = 32.dp),
                verticalArrangement = Arrangement.spacedBy(24.dp),
            ) {
                WebBackLink(
                    label = "Back",
                    onClick = { navHostController.popBackStack() },
                )

                WebSectionHeader(
                    title = document.title,
                    subtitle = document.subtitle,
                )

                LegalDocumentBody(document = document)

                Column(verticalArrangement = Arrangement.spacedBy(4.dp)) {
                    Text(
                        text = "Related documents",
                        style = MaterialTheme.typography.labelLarge,
                        fontWeight = FontWeight.SemiBold,
                        color = SpendTelReportColors.inkMuted,
                    )
                    TextButton(
                        onClick = {
                            navHostController.navigate(legalDocumentRoute(companionType)) {
                                popUpTo(
                                    when (documentType) {
                                        LegalDocumentType.PrivacyPolicy -> AppRoutes.PrivacyPolicy.name
                                        LegalDocumentType.TermsAndConditions -> AppRoutes.TermsAndConditions.name
                                    },
                                ) {
                                    inclusive = true
                                }
                            }
                        },
                    ) {
                        Text(companionDocument.title)
                    }
                }
            }
        }
    }
}
